import { Navigate, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../features/auth/state/useAuth'
import { ROUTES } from '../routes'

export function PublicOnlyRoute() {
  const { t } = useTranslation()
  const auth = useAuth()

  if (auth.isLoading) {
    return (
      <div className="grid min-h-screen place-items-center bg-background px-4">
        <p className="text-sm text-muted-foreground">{t('auth.checkingSession')}</p>
      </div>
    )
  }

  if (auth.isAuthenticated) {
    return <Navigate to={ROUTES.app.root} replace />
  }

  return <Outlet />
}
